import {Box, Skeleton} from '@mantine/core';
import type React from 'react';

export const CardSkelton: React.FC = () => {
  return (
    <Box className="bg-white mb-[10px] px-20 py-[10px] text-base text-black-1">
      <Box className="flex flex-col">
        <Box className="flex">
          <Skeleton height={70} width={70} />
          <Box className="flex flex-col w-full ml-12 justify-between">
            <Skeleton height={30} width="70%" />
            <Skeleton height={20} width="30%" mt={10} />
          </Box>
        </Box>
        <Box className="flex w-full mt-12 gap-8">
          <Skeleton height={20} width={80} radius="xl" />
          <Skeleton height={20} width={80} radius="xl" />
          <Skeleton height={20} width={80} radius="xl" />
          <Skeleton height={20} width={80} radius="xl" />
        </Box>
        <Box className="flex w-full mt-12">
          <Skeleton height={100} width="100%" />
        </Box>
        <Box className="flex w-full mt-12 justify-end">
          <Skeleton height={40} width={120} ml={10} />
          <Skeleton height={40} width={120} ml={10} />
        </Box>
      </Box>
    </Box>
  );
};

export const CardSkeltonSP: React.FC = () => {
  return (
    <Box className="bg-white w-ful bow-full border-t-2 border-line p-16">
      <Box className="flex flex-col">
        <Box className="flex">
          <Skeleton height={70} width={100} />
          <Box className="flex flex-col w-full ml-12 justify-between">
            <Skeleton height={30} width="80%" />
            <Skeleton height={20} width="40%" mt={10} />
          </Box>
        </Box>
        <Box className="flex w-full mt-12 gap-8">
          <Skeleton height={20} width={80} radius="xl" />
          <Skeleton height={20} width={80} radius="xl" />
          <Skeleton height={20} width={80} radius="xl" />
        </Box>
        <Box className="flex w-full mt-12">
          <Skeleton height={80} width="100%" />
        </Box>
        <Box className="flex w-full mt-12 justify-end">
          <Skeleton height={40} width={120} ml={10} />
          <Skeleton height={40} width={120} ml={10} />
        </Box>
      </Box>
    </Box>
  );
};
